import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import styles from './DateBox.css';

class DateBox extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className="row">
          <div className="col-md-12">
            <table className={styles.table}>
              <thead>
                <tr>
                  {this._getDaysOfWeek().map((dateObj, idx) => {
                    return <th key={idx}>{dateObj.format('ddd')}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {this._getCalendarWeeks().map((week, widx) => {
                  return (
                    <tr key={widx}>
                      {week.map((dateObj, idx) => {
                        const fadedDay = this._isPartOfMonth(dateObj)
                          ? ''
                          : `fadedDay`;
                        const selectedBetweenDate = this._isPartOfSelected(
                          dateObj
                        )
                          ? `selected`
                          : '';
                        const selectedStartDate = this._isSelectedStartDate(
                          dateObj
                        )
                          ? 'selected-start-date'
                          : '';
                        const selectedEndDate = this._isSelectedEndDate(dateObj)
                          ? 'selected-end-date'
                          : '';
                        const disabled = DateBox._isPastDate(dateObj)
                          ? 'disabled'
                          : '';
                        const cssClass = [
                          'day',
                          fadedDay,
                          selectedBetweenDate,
                          selectedStartDate,
                          selectedEndDate,
                          disabled,
                        ].join(' ');
                        return (
                          <td key={idx} className={cssClass}>
                            <a
                              className={styles.anchor}
                              disabled={DateBox._isPastDate(dateObj)}
                              onClick={() => this._onClickDate(dateObj)}
                            >
                              {dateObj.date()}
                            </a>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    );
  }

  _getDaysOfWeek = () => {
    const daysOfWeek = [];
    const d = moment().startOf('week');
    for (let i = 0; i < 7; i++) {
      daysOfWeek.push(moment(d));
      d.add(1, 'days');
    }
    return daysOfWeek;
  };

  _getCalendarWeeks() {
    const { year, month } = this.props;
    const calendar = [];
    const dateIterator = moment({ year, month })
      .startOf('month')
      .startOf('week');
    let weekIterator = 0;
    let dayIterator = 0; // day of week iterator

    // 42 days
    for (let i = 0; i < 42; i++) {
      if (calendar[weekIterator] === undefined) {
        calendar[weekIterator] = [];
      }
      // must be new object!
      calendar[weekIterator][dayIterator] = moment(dateIterator);
      // if day of week is saturday, rest
      if (dateIterator.day() === 6) {
        weekIterator += 1;
        dayIterator = 0;
        calendar[weekIterator] = [];
      } else {
        dayIterator++;
      }
      dateIterator.add(1, 'days');
    }
    return calendar;
  }

  /**
   * Check whether a date object is part of month
   * @param {Date} date
   * @return {boolean}
   * @private
   */
  _isPartOfMonth(date) {
    const { year, month } = this.props;
    const startOfMonth = moment({ year, month }).startOf('month');
    const endOfMonth = moment({ year, month }).endOf('month');
    return date.isBetween(startOfMonth, endOfMonth, null, '[]');
  }

  /**
   * Check whether a date is selected by user
   * @param {Date} date
   * @return {boolean}
   * @private
   */
  _isPartOfSelected(date) {
    const { startDate, endDate } = this.props;
    return (
      startDate &&
      endDate &&
      date.isBetween(moment(startDate), moment(endDate), null, '[]')
    );
  }

  static _isPastDate(date) {
    return date.isBefore(moment().add(-1, 'days'));
  }

  _isSelectedStartDate(date) {
    const { startDate } = this.props;
    return startDate && moment(startDate).isSame(date);
  }

  _isSelectedEndDate(date) {
    const { endDate } = this.props;
    return endDate && moment(endDate).isSame(date);
  }

  _onClickDate = date => {
    // do nothing if the selected is past date
    if (DateBox._isPastDate(date)) {
      return false;
    }

    /**
     * We need to check, if start and end date is same, then we need to check
     * current date is before start date and current date is after end date
     */
    const { startDate, endDate, onChange } = this.props;
    const isStartAndEndSame = moment(startDate).isSame(endDate);
    onChange({
      startDate: isStartAndEndSame
        ? date.isBefore(startDate)
          ? date
          : startDate
        : date,
      endDate: isStartAndEndSame
        ? date.isAfter(endDate)
          ? date
          : endDate
        : date,
    });
  };
}

DateBox.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onChange: PropTypes.func,
};

export default DateBox;
